import React from 'react';
import { Switch as AntdSwitch } from 'antd';
import classNames from 'classnames';

interface IProps {
	className?: string;
	checked: boolean;
	isDisabled?: boolean;
	testId?: string;
	onChange: () => void;
}

const ANTD_OVERRIDES = [
	'w-15.5 h-8 border-2 border-solid',
	'[&_.ant-switch-handle]:top-px [&_.ant-switch-handle]:left-px',
	'[&_.ant-switch-handle]:w-6.5 [&_.ant-switch-handle]:h-6.5',
	'[&.ant-switch-checked_.ant-switch-handle]:translate-x-7.5',
	'[&_.ant-switch-handle::before]:rounded-full',
].join(' ');

export const Switch: React.FC<IProps> = React.memo(({ className, checked, isDisabled = false, testId, onChange }) => {
	const switchClasses = classNames(
		ANTD_OVERRIDES,
		{
			'border-green-06-new bg-green-06-new hover:border-green-07-new hover:bg-green-07-new':
				checked && !isDisabled,
			'border-grey-04-new bg-white-00-new [&_.ant-switch-handle::before]:bg-grey-04-new': !checked && !isDisabled,
			'border-grey-03-new bg-white-00-new [&_.ant-switch-handle::before]:bg-grey-03-new opacity-100':
				!checked && isDisabled,
			'border-green-03-new bg-green-03-new [&_.ant-switch-handle::before]:bg-white-00-new opacity-100':
				checked && isDisabled,
		},
		className,
	);

	return (
		<AntdSwitch
			className={switchClasses}
			checked={checked}
			disabled={isDisabled}
			onChange={onChange}
			data-test={testId}
		/>
	);
});
